import { inject, REQUEST, REQUEST_CONTEXT, Type } from '@angular/core';
import type * as express from 'express';

export interface TYTRequestContext {
    request: express.Request;
    response: express.Response;
    apmServiceClass: unknown;
    redirection: { url: string };
}

/**
 * Retrieve the low-level request context. This can be used to interact directly
 * with Express when running on the server (bypassing Angular SSR's own facilities).
 * @returns
 */
export function injectRequestContext() {
    let context = inject(REQUEST_CONTEXT, { optional: true }) as TYTRequestContext;
    return context;
}

export function injectRequest() {
    const context = injectRequestContext();
    return context?.request;
}

export function injectResponse() {
    const context = injectRequestContext();
    return context?.response;
}